module.exports = __webpack_public_path__ + "static/media/nervousSystem.5fdc590d.png";